export default class ContentStack extends HTMLElement {
    constructor() {
        super();
    }
}

window.customElements.define('nc-content-stack', ContentStack);
